import { createAxiosClient } from "@ntg/component-library/utilities";
import { IFunctionStatusResponse } from "../../declarations/IFunctionsResponse";
import { useQuery } from "@tanstack/react-query";

async function fetchStatus(
    instanceId: string,
): Promise<IFunctionStatusResponse> {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IFunctionStatusResponse>(
        `/FunctionAppsStarter/GetOrchestratorStatus/${instanceId}`,
    );
    return response.data;
}

export function useOrchestrationStatus(instanceId: string) {
    return useQuery({
        queryKey: ["orchestration-status", instanceId],
        queryFn: () => fetchStatus(instanceId),
        enabled: instanceId.length > 0,
        refetchInterval: (data: any) => {
            // Auto-stop polling when completed/failed/terminated
            if (!data) return 750; // still loading → keep polling

            const status = data?.state?.data?.runtimeStatus;
            if (status === undefined) {
                return 750; // still loading → keep polling
            }

            if (
                status === "Completed" ||
                status === "Failed" ||
                status === "Terminated"
            ) {
                return false; // stop polling
            }

            return 750; // poll every 0.75 seconds
        },
        staleTime: 0,
        refetchOnWindowFocus: false,
    });
}
